export default {
    "beheizungen": {
        "dickschicht": {
            "name": "Dickschichttechnologie",
            "align": "right"
        },
        "induktion": {
            "name": "Induktionstechnologie",
            "align": "left"
        },
        "strahlungsheizkoerper": {
            "name": "Strahlungsheizkörper",
            "align": "left"
        },
        "kochplatte": {
            "name": "Kochplatte",
            "align": "left"
        },
        "rohrheizkoerper": {
            "name": "Rohrheizkörper",
            "align": "right"
        },
    },
    "steuerungen": {
        "thermostate": {
            "name": "Thermostate",
            "align": "right"
        },
        "schalter": {
            "name": "Schalter",
            "align": "left"
        },
        "bedienoberflaechen": {
            "name": "Bedienoberflächen",
            "align": "right"
        },
        "codeschalter": {
            "name": "Codeschalter",
            "align": "right"
        },
        "mainboards": {
            "name": "Mainboards",
            "align": "right"
        },
        "energieregler": {
            "name": "Energieregler",
            "align": "right"
        }
    },
    "aktoren": {
        "motorsteuerung": {
            "name": "Motorsteuerung",
            "align": "right"
        },
        "motorheizpumpe": {
            "name": "Motorheizpumpe",
            "align": "left"
        },
        "dampfgenerator": {
            "name": "Dampfgenerator",
            "align": "left"
        }
    }
}